module.exports = __webpack_public_path__ + "static/media/Frame 2825.c86c9887.jpg";